import DashboardLayout from '../layouts/DashboardLayout'
// import ContactSourceList from '../pages/contact-source/ContactSourceList'
// import ContactStatusList from '../pages/contact-status/ContactStatusList'
// import RoleList from '../pages/roles/RoleList'
// import RoleForm from '../pages/roles/RoleForm'

// import ContactSetting from '../pages/contact/ContactSetting'
// import Announcement from '../pages/announcement/Announcement'

// import SchoolLevel from '../pages/school-level/SchoolLevel'

export const dataSetting = {
  path: '/data-setting',
  component: DashboardLayout,
  name: 'DataSetting',
  redirect: '/data-setting',
  children: [
    {
      path: 'contact-setting',
      name: 'ContactSetting',
      component: () => import(/* webpackChunkName: "about" */'../pages/contact/ContactSetting.vue'),
      meta: {
        roles: ['contact-setting_read','contact-setting_create','contact-setting_update','contact-setting_delete'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Cài đặt khách hàng',
        }]
      },
    },
    {
      path: 'contact-source-list',
      name: 'Contact Source List',
      component: () => import(/* webpackChunkName: "about" */'../pages/contact-source/ContactSourceList.vue'),
      meta: {
        roles: ['contact-source_read','contact-source_create','contact-source_update','contact-source_delete'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Nguồn khách hàng',
        }]
      },
    },
    {
      path: 'contact-status',
      name: 'ContactStatusList',
      component: () => import(/* webpackChunkName: "about" */'../pages/contact-status/ContactStatusList.vue'),
      meta: {
        roles: ['contact-status_read','contact-status_create','contact-status_update','contact-status_delete'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách mối quan hệ',
        }]
      }
    },
    {
      path: 'announcement',
      name: 'AnnouncementList',
      component: () => import(/* webpackChunkName: "about" */'../pages/announcement/Announcement.vue'),
      meta: {
        roles: ['announcement_read'],
        requiresAuth: true,
        breadcrumb: [{
            title: 'Danh sách thông báo',
        }]
      },
    },
    {
      path: 'school-level',
      name: 'SchoolLevelList',
      component: () => import(/* webpackChunkName: "about" */'../pages/school-level/SchoolLevel.vue'),
      meta: {
        roles: ['school-level_read'],
        requiresAuth: true,
        breadcrumb: [{
            title: 'Danh sách nhóm ngành',
        }]
      },
    },
    {
      path: 'priority',
      name: 'prioritySetting',
      component: () => import('../pages/priority-setting/PrioritySettingList'),
      meta: {
        roles: ['priority-setting_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Cấu hình độ ưu tiên',
        }]
      },
    },
    {
      path: 'hold-contact',
      name: 'holdContactSettingList',
      component: () => import('../pages/hold-contact-setting/HoldContactSettingList'),
      meta: {
        roles: ['keep-contact-setting_read'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Cấu hình ngày giữ contact',
        }]
      },
    }
  ],
}